import { css } from '@emotion/react';

import type { Brand } from '../../types/brand';

const chartComparisonTableStyles = (theme: Brand) =>
  css({
    table: {
      minWidth: '500px',
      margin: '50px auto',
      display: 'flex',
      flexFlow: 'row wrap',
      borderSpacing: '0',
      border: 'none',
      borderCollapse: 'collapse',
      paddingBottom: '40px',
      tbody: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      },
      tr: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        transition: 'background-color ease .2s',
        ':nth-of-type(even)': {
          backgroundColor: theme.colors.coolGrey[5],
        },
        ':hover': {
          backgroundColor: theme.colors.indigo[5],
        },
        '&.table-header': {
          backgroundColor: theme.colors.coolGrey[80],
          borderRadius: '5px 5px 0 0',
          color: theme.colors.white,
          marginBottom: '-1px',
        },
        '&.table-sub': {
          backgroundColor: theme.colors.coolGrey[80],
          color: theme.colors.white,
          marginBottom: '-1px',
        },
        [theme.breakpoints.bp900.min]: {
          width: '60%',
        },
        img: {
          width: '18px',
          height: '20px',
          marginBottom: '-7px',
        },
        '.table-column': {
          height: '100%',
          display: 'none',
          width: '66% !important',
          textAlign: 'center',
          padding: '0 20px',
          verticalAlign: 'top',
          marginTop: '-2.5em',
          position: 'absolute',
          color: theme.colors.coolGrey[100],
          right: '-66%',
          [theme.breakpoints.bp900.min]: {
            display: 'inline-block',
          },
          p: {
            textAlign: 'center',
            backgroundColor: '#F2F2F2',
            borderRadius: '10px',
            position: 'relative',
            margin: '0',
            padding: '15px 10px',
            lineHeight: theme.lineHeights.lh1_2,
            ':before': {
              content: '""',
              borderStyle: 'solid',
              borderWidth: '10px 15px 10px 0',
              borderColor: 'transparent #F2F2F2 transparent transparent',
              position: 'absolute',
              left: '-14px',
            },
          },
        },
      },
      'th, td': {
        fontWeight: '400',
        textAlign: 'center',
        padding: `${theme.space.s8}px 0`,
        ':first-of-type': {
          width: '50%',
          paddingLeft: '15px',
          textAlign: 'left',
        },
        width: '25%',
        p: {
          margin: 0,
          padding: 0,
          textAlign: 'left',
          lineHeight: theme.lineHeights.lh1_35,
        },
        img: {
          display: 'inline-block',
          padding: '0 !important',
          '&.transparent': {
            opacity: '0.6',
          },
        },
      },
      // Alternate styles for other table type
      '&#compare-table': {
        marginRight: '24px',
        tr: {
          width: '100%',
        },
        'tr:first-of-type td': {
          padding: `${theme.space.s16}px 0`,
          fontWeight: theme.fontWeights.fw500,
          background: 'white',
          [theme.breakpoints.bp900.min]: {
            fontSize: theme.fontSizes.fs20,
          },
          '&:nth-of-type(2)': {
            minWidth: '140px',
            background: theme.colors.coolGrey[20],
            [theme.breakpoints.bp900.min]: {
              width: '280px',
            },
          },
          '&:last-of-type': {
            minWidth: '140px',
            background: theme.colors.orange[20],
            [theme.breakpoints.bp900.min]: {
              width: '280px',
            },
          },
          p: {
            textAlign: 'center',
            fontWeight: theme.fontWeights.fw500,
          },
        },
        td: {
          background: theme.colors.coolGrey[5],
          padding: `${theme.space.s8}px`,
          '&:first-of-type': {
            minWidth: '160px',
            [theme.breakpoints.bp900.min]: {
              maxWidth: 'none',
            },
          },
          '&:last-of-type': {
            background: theme.colors.orange[5],
          },
          img: {
            width: '25px',
            height: 'auto',
            margin: '0 5px',
          },
        },
        p: {
          color: theme.colors.coolGrey[70],
          fontSize: theme.fontSizes.fs12,
          display: 'none',
          [theme.breakpoints.bp768.min]: {
            display: 'block',
          },
          '&:first-of-type': {
            display: 'block',
            color: theme.colors.coolGrey[80],
            fontSize: theme.fontSizes.fs12,
            [theme.breakpoints.bp900.min]: {
              fontSize: theme.fontSizes.fs16,
            },
          },
        },
      },
    },
  });

export default chartComparisonTableStyles;
